// extracted by mini-css-extract-plugin
export var block = "footer-module--block--2vd7h";
export var blueVariant = "footer-module--blueVariant--6GEDZ";
export var br = "footer-module--br--TE9pm";
export var button = "footer-module--button--ybPer";
export var checkNumber = "footer-module--checkNumber--ONWha";
export var darkVariant = "footer-module--darkVariant--xKHy+";
export var dkpzMediaVariant = "footer-module--dkpzMediaVariant--WLX9r";
export var footerColor = "footer-module--footerColor--jMIHa";
export var hide = "footer-module--hide--BMK7P";
export var mainPage = "footer-module--mainPage--2UVnZ";
export var marginTop = "footer-module--marginTop--VHCyb";
export var paleVariant = "footer-module--paleVariant--2Nrx1";
export var redButton = "footer-module--redButton--PRFSO";
export var text = "footer-module--text--MhnMV";
export var whiteText = "footer-module--whiteText--Svdq9";
export var wrapper = "footer-module--wrapper--BEZHJ";
export var wrapperButtonFloating = "footer-module--wrapperButtonFloating--DLYG1";
export var wrapperDarkVariant = "footer-module--wrapperDarkVariant--YDkXE";
export var wrapperDarkVariantButtonFloating = "footer-module--wrapperDarkVariantButtonFloating--ffOwP";